export const menu = [{
  name: "首页",
  url: "/UC/User",
  icon: "icon-shouye",
  children: [
    // {
    //   name: "个人中心",
    //   url: "/UC/Center/UserCenter",
    //   icon: ""
    // }, {
    //   name: "消息中心",
    //   url: "/UC/InfoCenter",
    //   icon: "",
    // }
  ]
},
{
  name: "基金管理机构",
  url: "/FundManagement/FundList",
  icon: "icon-jijinguanlijigou",
  children: [
    //   {
    //   name: "机构列表",
    //   url: "/FundManagement/FundList",
    //   icon: "",
    // }, 
    // {
    //   name: "新设机构",
    //   url: "/FundManagement/NewAgency?flag=new",
    //   icon: "",
    // },
    //  {
    //   name: "变更机构",
    //   // url: "/FundManagement/UpdataAgency",
    //   url: "/FundManagement/NewAgency?flag=update",
    //   icon: "",
    // },
    // {
    //   name: "迁入机构",
    //   url: "/FundManagement/NewAgency?flag=add",
    //   icon: "",
    // }
  ]
}, {
  name: "入驻申请",
  url: "/FundAgency/FundList",
  icon: "icon-jijinjigou",
  children: [
    //   {
    //   name: "机构列表",
    //   url: "/FundAgency/FundList",
    //   icon: "",
    // }, 
    // {
    //   name: "新设机构",
    //   url: "/FundAgency/Agency?flag=new",
    //   icon: "",
    // }, {
    //   name: "迁入机构",
    //   url: "/FundAgency/Agency?flag=add",
    //   icon: "",
    // }
  ]
},
{
  name: "审核进度",
  url: "/Audit/List",
  icon: "icon-shenhejindu"
}, {
  name: "季报管理",
  url: "/QuaReport/Record",
  icon: "icon-jibaoguanli",
  children: [
    //   {
    //   name: "季报记录",
    //   url: "/QuaReport/Record",
    //   icon: "",
    // }
  ]
}, {
  name: "小镇服务",
  url: "/Town",
  icon: "icon-xiaozhenfuwu",
  children: [{
    name: "登记注册服务",
    url: "/Town/Affairs",
    icon: "",
  }, {
    name: "基金业务服务",
    url: "/Town/Fund",
    icon: "",
  }, {
    name: "政策法规",
    url: "/Town/Laws",
    icon: "",
  },
  {
    name: '小镇活动',
    url: "https://www.xjfundtown.cn/news/8/",
    icon: ""
  },
  {
    name: '新闻公告',
    url: "https://www.xjfundtown.cn/news/12/",
    icon: ""
  },
  // {
  //   name: '入驻政策',
  //   url: "https://www.xjfundtown.cn/dxgs.html",
  //   icon: ""
  // }
]
}, {
  name: "信息公示",
  url: "/Publicity",
  icon: "icon-xinxigongshi"
}];

export const reportPlatform = [{
  name: "举报平台",
  url: "/ReportPlatform/ReportList",
  icon: "icon-jubaopingtai",
  children: [
    {
      name: "举报列表",
      url: "/ReportPlatform/ReportList",
      icon: "",
    },
    {
      name: "发起举报",
      url: "/ReportPlatform/InitiateReport",
      icon: "",
    },
    {
      name: "举报说明",
      url: "/ReportPlatform/Description",
      icon: "",
    }
  ]
},
{
  name: "信息公示",
  url: "/Publicity",
  icon: "icon-xinxigongshi"
}]
